document.querySelectorAll('[data-header-image]').forEach((el) => {
  let headerImage = el.dataset.headerImage
  let bannerImageElement = document.querySelector('.cm-banner-fadeout img')
  if(!(headerImage && bannerImageElement)) return

  el.addEventListener('click', (e) => {
    bannerImageElement.setAttribute('src', headerImage)
    bannerImageElement.setAttribute('srcset', '')
  })
})